import styled from 'styled-components';

export const MobileBottomSpacing = styled.div.withConfig({ componentId: 'sc-rb24oi-0' })`
  padding-bottom: 150px;
`;
